export default {
    value: '',
    label: '',
    disabled: true,
    hidden: true,
};
